// Unpublished Work © 2022-2023 Deere & Company.

import t from 'tcomb';
import {CustomerProfileStatus, customerProfileStatus} from '../../enum/customer-status';
import {customerTypes} from '../../enum/customer-type';
import {Customer} from '../customer';
import {businessNameFieldKeys, contactNameFieldKeys} from './dbs-field-keys';

export const DbsCustomer = Customer.extend({
    arNumber: t.Number,
    dbsNumber: t.String,
    inactiveReason: t.maybe(t.String),
    inactiveInd: CustomerProfileStatus,
    rewardsNumber: t.Number
}, {
    defaultProps: {
        arNumber: 0,
        dbsNumber: '',
        inactiveReason: '',
        inactiveInd: customerProfileStatus.ACTIVE,
        rewardsNumber: 0
    },
    name: 'DbsCustomer'
});

DbsCustomer.prototype.isCustomerProfileInactive = function () {
    return {
        [customerProfileStatus.ACTIVE]: false,
        [customerProfileStatus.INACTIVE]: true
    }[this.inactiveInd];
};

DbsCustomer.prototype.getContactNameLabels = function () {
    const individualNameKeys = Object.values(contactNameFieldKeys);
    const businessNameKeys = Object.values(businessNameFieldKeys);

    if (this.customerType === customerTypes.INDIVIDUAL) {
        return individualNameKeys;
    } else if (this.customerType === customerTypes.BUSINESS) {
        return businessNameKeys;
    }

    return [
        ...businessNameKeys,
        ...individualNameKeys
    ];
};
